import React from "react";
import "./FormFields.css";

const TextArea = ({
  label,
  value,
  onChange,
  placeholder = "",
  required = false,
  readOnly = false,
  minHeight = "100px",
  style = {},
  className = "",
  labelStyle = {},
  textareaStyle = {},
  ...props
}) => {
  // Determine height class
  const getHeightClass = () => {
    if (minHeight === "80px") return "form-textarea-height-small";
    if (minHeight === "150px") return "form-textarea-height-large";
    return "form-textarea-height-medium"; // default 100px
  };

  const textareaClassName = `form-textarea ${getHeightClass()}`;
  const labelClassName = "form-field-label";

  return (
    <div className={`form-group ${className}`} style={style}>
      <label className={labelClassName} style={labelStyle}>
        {label}
        {required && (
          <span className="form-field-required">
            *
          </span>
        )}
      </label>
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        className={textareaClassName}
        style={{ minHeight, ...textareaStyle }}
        {...props}
      />
    </div>
  );
};

export default TextArea;
